"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var clamp_js_main_1 = __importDefault(require("clamp-js-main"));

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Grid_1 = require("../../atoms/Grid");

var Headline_1 = require("../../atoms/Headline");

var Icon_1 = require("../../atoms/Icon");

var Paragraph_1 = require("../../atoms/Paragraph");

var Section_1 = require("../../atoms/Section");

var Theme_1 = require("../../atoms/Theme");

var IconLink_1 = require("../../molecules/IconLink");

var Layer_1 = require("../../molecules/Layer");

var Tabs_1 = require("../../molecules/Tabs");

var TextSection_1 = require("../../molecules/TextSection");

var ContentWrapper =
/** @class */
function (_super) {
  __extends(ContentWrapper, _super);

  function ContentWrapper(props) {
    var _this = _super.call(this, props) || this;

    _this.uuid = uniqid_1["default"]("contentwrapper-");

    _this.onViewportChange = function (viewport) {
      _this.setState({
        isMobile: ["md", "sm", "xs"].includes(viewport)
      });
    };

    _this.onResize = function () {
      if (_this.mobileRef) {
        Array.prototype.slice.call(_this.mobileRef.querySelectorAll("." + CSSPrefix_1.lsgPre + "copy-text")).map(function (element) {
          clamp_js_main_1["default"](element, {
            clamp: 3
          });
        });
      }
    };

    _this.onCloseDrawer = function () {
      _this.setState({
        drawerOpenIndex: undefined
      });
    };

    _this.onOpenDrawer = function (drawerOpenIndex) {
      _this.setState({
        drawerOpenIndex: drawerOpenIndex
      });
    };

    _this.onChangeDesktop = function (openIndex) {
      _this.setState({
        openIndex: openIndex + 1
      });
    };

    _this.onChangeMobile = function (openIndex) {
      _this.setState({
        openIndex: openIndex
      });
    };

    _this.state = {
      openIndex: 0,
      isMobile: ["md", "sm", "xs"].includes(utils_1.WindowEvents.getViewportSize())
    };
    return _this;
  }

  ContentWrapper.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.onViewportChange);
    utils_1.WindowEvents.addResizeCallback(this.onResize);
  };

  ContentWrapper.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.onViewportChange);
    utils_1.WindowEvents.removeResizeCallback(this.onResize);
  };

  ContentWrapper.prototype.renderTextSection = function (block, text, id) {
    return React.createElement(TextSection_1.TextSection, {
      label: block.label,
      title: block.headline,
      titleSize: Headline_1.Headline.Sizes.H3,
      signal: block.signal,
      id: id
    }, text || block.text);
  };

  ContentWrapper.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        blocks = _a.blocks,
        headline = _a.headline,
        theme = _a.theme,
        id = _a.id;
    var _b = this.state,
        openIndex = _b.openIndex,
        isMobile = _b.isMobile,
        drawerOpenIndex = _b.drawerOpenIndex;
    var uuid = id || this.uuid;
    var result = React.createElement(Section_1.Section, {
      fullWidth: true,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "contentwrapper"])
    }, React.createElement(Section_1.Section.Content, null, React.createElement(Headline_1.H2, null, headline)), !isMobile && React.createElement(Section_1.Section.Content, {
      key: "desktopSection"
    }, blocks.length > 0 && React.createElement(Grid_1.Grid.Row, {
      verticalAlign: Grid_1.Grid.VerticalAlign.MIDDLE,
      gap: Grid_1.Grid.Spacing.SECTION,
      key: "firstBlock"
    }, React.createElement(Grid_1.Grid.Column, {
      size: Grid_1.Grid.Sizes.HALF
    }, this.renderTextSection(blocks[0])), React.createElement(Grid_1.Grid.Column, {
      size: Grid_1.Grid.Sizes.HALF,
      textAlign: Grid_1.Grid.TextAlign.CENTER
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "contentwrapper-illustration"
    }, blocks[0].illustration))), blocks.length > 2 && React.createElement(Tabs_1.Tabs, {
      isMobile: false,
      openIndex: Math.max(openIndex - 1, 0),
      onChange: this.onChangeDesktop,
      key: "tabsBlock"
    }, blocks.slice(1, -1).map(function (block) {
      return React.createElement(Tabs_1.Tabs.Tab, {
        label: block.tabLabel || block.label,
        key: block.key
      }, React.createElement(Grid_1.Grid.Row, {
        verticalAlign: Grid_1.Grid.VerticalAlign.MIDDLE,
        gap: Grid_1.Grid.Spacing.SECTION
      }, React.createElement(Grid_1.Grid.Column, {
        size: Grid_1.Grid.Sizes.HALF,
        textAlign: Grid_1.Grid.TextAlign.CENTER
      }, React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "contentwrapper-illustration"
      }, block.illustration)), React.createElement(Grid_1.Grid.Column, {
        size: Grid_1.Grid.Sizes.HALF
      }, _this.renderTextSection(block))));
    })), blocks.length > 1 && React.createElement(Grid_1.Grid.Row, {
      verticalAlign: Grid_1.Grid.VerticalAlign.MIDDLE,
      gap: Grid_1.Grid.Spacing.SECTION,
      key: "lastBlock"
    }, React.createElement(Grid_1.Grid.Column, {
      size: Grid_1.Grid.Sizes.HALF
    }, this.renderTextSection(blocks.slice(-1)[0])), React.createElement(Grid_1.Grid.Column, {
      size: Grid_1.Grid.Sizes.HALF,
      textAlign: Grid_1.Grid.TextAlign.CENTER
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "contentwrapper-illustration"
    }, blocks.slice(-1)[0].illustration)))), isMobile && React.createElement("div", {
      ref: function ref(r) {
        return _this.mobileRef = r;
      },
      key: "gallery"
    }, React.createElement(Tabs_1.Tabs, {
      isMobile: true,
      openIndex: openIndex,
      onChange: this.onChangeMobile
    }, blocks.map(function (block, i) {
      return React.createElement(Tabs_1.Tabs.Tab, {
        label: block.tabLabel || block.label,
        key: block.key
      }, React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "contentwrapper-gallery-element"
      }, _this.renderTextSection(block, React.createElement(Paragraph_1.Paragraph, null, block.mobileText)), React.createElement(IconLink_1.IconLink, {
        iconName: Icon_1.Icon.Names.interaction___add,
        onClick: function onClick() {
          return _this.onOpenDrawer(i);
        }
      }, utils_1.Localization.texts.lsg.component.ContentWrapper.showDetails)));
    }))), React.createElement(Layer_1.Layer, {
      open: drawerOpenIndex !== undefined,
      onCloseClick: this.onCloseDrawer,
      htmlAttrs: {
        "aria-labelledby": uuid + "-textsection-title",
        "aria-describedby": uuid + "-textsection-content"
      },
      closeLinkLabel: utils_1.Localization.texts.lsg.component.ContentWrapper.closeLayer
    }, drawerOpenIndex !== undefined && React.createElement(React.Fragment, null, this.renderTextSection(blocks[drawerOpenIndex], undefined, uuid + "-textsection"), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "contentwrapper-illustration"
    }, blocks[drawerOpenIndex].illustration))));

    if (theme) {
      return React.createElement(Theme_1.Theme, {
        look: theme
      }, result);
    }

    return result;
  };

  return ContentWrapper;
}(React.Component);

exports.ContentWrapper = ContentWrapper;